import { randomUUID } from '@aloft/toolkit-shared';
import { Image, Text } from '@react-pdf/renderer';

import { getCommentaryTableHelperText } from '../../../redux/features/selectors/utils/getCommentaryTableHelperText.ts';
import { COMMENTARY_TEXT, PNG_HEIGHT, PNG_WIDTH } from '../../commentary/consts.ts';
import { ExportChartContainer } from '../../commentary/export/ExportChartContainer.tsx';
import { ExportCommentaryTable } from '../../commentary/export/ExportCommentaryTable.tsx';
import { CommentarySection } from '../components/CommentarySection.tsx';
import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { fontStyles } from '../styles.ts';
import { DateOfSaleAdjustmentsPageProps } from '../types.ts';

export const DateOfSaleAdjustmentsPage = ({
  subjectAddress,
  adjustmentSettings,
  adjustmentsTableData,
  tkv2ChartImages: { dateOfSaleChartImage },
}: DateOfSaleAdjustmentsPageProps) => {
  const marketAdjustmentsTableData = adjustmentsTableData.marketAdjustments;
  const { method: listToSaleMethod } = adjustmentsTableData.listToSale ?? {};

  if (!marketAdjustmentsTableData || !listToSaleMethod) return null;

  const { commentary, method, tableData } = marketAdjustmentsTableData;

  const { title, subtitle } = COMMENTARY_TEXT['date-of-sale-adjustments'];
  const helperText = getCommentaryTableHelperText(adjustmentSettings, 'dateOfSale');

  return (
    <Tkv2PDFPage title={title} address={subjectAddress}>
      <Text style={fontStyles.body}>{subtitle}</Text>
      {dateOfSaleChartImage && (
        <ExportChartContainer
          title={method === 'zillow' ? 'Zillow Home Value Index' : 'Custom Home Value Index'}
        >
          <Image src={dateOfSaleChartImage} style={{ height: PNG_HEIGHT, width: PNG_WIDTH }} />
        </ExportChartContainer>
      )}
      {tableData.map(
        (table, index) =>
          table && (
            <ExportCommentaryTable
              key={randomUUID()}
              data={table.map((row) => row.map((cell) => cell.value)) as [string[], ...string[][]]}
              helperText={
                index === tableData.length - 1 && listToSaleMethod === 'none'
                  ? helperText
                  : undefined
              }
            />
          ),
      )}
      <CommentarySection title="Date of Sale Commentary" commentary={commentary} />
    </Tkv2PDFPage>
  );
};
